exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1280px) {\n  .content {\n    width: 1280px;\n    margin: auto; }\n    .content h1 {\n      font-size: 3em; }\n    .content h2 {\n      font-size: 0.85em; }\n    .content h3 {\n      font-size: 1em;\n      margin-bottom: 2em; } }\n\n@media (max-width: 1279px) {\n  .content {\n    width: 90%; } }\n\n.main .content {\n  margin-bottom: 2rem; }\n  .main .content h1 {\n    font-weight: 800;\n    text-transform: uppercase; }\n  .main .content h3 {\n    font-size: 1em;\n    font-style: italic; }\n  .main .content h2 {\n    font-style: italic;\n    font-size: 1em;\n    line-height: 2em;\n    font-weight: 300;\n    white-space: pre-line; }\n  .main .content .about-me p {\n    font-weight: 300;\n    line-height: 2em;\n    white-space: pre-line;\n    font-size: 1em; }\n    .main .content .about-me p strong {\n      font-weight: 800; }\n  .main .content .about-me h3 {\n    font-size: 1em;\n    line-height: 2em;\n    font-weight: 800;\n    white-space: pre-line; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/timva/Documents/Work/LatestDownload/src/app/about/about.component.scss
// module id = ../../../../../src/app/about/about.component.scss
// module chunks = main